import { t as translation } from 'i18next'
import { List } from 'immutable'
import 'whatwg-fetch'
import {
  Action,
  AsyncState,
  Fun,
  mk_pair,
  none,
  Option,
  Pair,
  unloadedAsyncState,
  Widget
} from 'widgets-for-react'
import { TemplateState } from './cms/page/types.gen'
import { PageTemplateState } from './cms/state/types.gen'
import { get_options, get_page, InitPagesStates, PublicSite_CustomPageData } from './public_site/application.mod'
import { CustomBlockData } from './public_site/blocks/custom_blocks/types.mod'
import { blocks_renderer } from './public_site/blocks/renderer.mod'
import { CustomPagesState } from './public_site/custom_pages/types.mod'
import { cookieTypes } from './public_site/templates/cookiebar.mod'
import { getRegionSwitchData as getRegionSwitchSelectors } from './public_site/templates/regionSwitch/regionSwitchApi.mod'
import { RegionSwitchState } from './public_site/templates/regionSwitch/regionSwitchState.mod'
import { ExtraImages } from './public_site/utils/extra_images.mod'
import { CustomBlock } from './wordpress/types_and_parser/custom_blocks.mod'
import { Breadcrumb } from './wordpress/types_and_parser/extra_types.mod'
import { Block } from './wordpress/types_and_parser/standard_blocks.gen'
import { ParsedNode } from './wordpress/types_and_parser/types.ext.gen'
// import { getCookieStatus } from './cms/blocks/cookiebar.utils.mod'
import { WordPress } from './wordpress/wordpress_api'


export type HeaderState = {
  menu_header: HeaderMenus
  menu: 'closed' | 'open'
  contactbar: 'closed' | 'open'
  lang: 'closed' | 'open'
  showSearchBar: boolean
  searchValue: string
  hoveredItem?: WordPress.MenuItem
}

export type CookieState = {
  cookiebar: 'closed' | 'open'
  selectedCookie: cookieTypes
}

export type HeaderMenus = {
  // nav_links: AsyncState<List<ParsedMenuItem>>
  breadcrumb: AsyncState<List<{}>>
}

export type FooterState = {
  menu_footer: FooterMenus
}

export type FooterMenus = {
  // nav_links: AsyncState<List<ParsedMenuItem>>
}

export type BrowserState = {
  viewport: 'mobile' | 'tablet' | 'desktop' | 'large'
}

export type OptionsState = AsyncState<WordPress.OptionsResponse>

export type PublicSiteState = {
  regionSwitch: RegionSwitchState;
  header: HeaderState;
  // cookiebar: CookieState;
  footer: FooterState;
  browser: BrowserState;
  options: OptionsState;
  heroColor: string;
} & PageTemplateState<
  CustomBlockData,
  CustomBlock,
  Block,
  ExtraImages,
  PublicSite_CustomPageData,
  any // change this to PublicSiteState when circular reference is supported in TS
> &
  CustomPagesState;


export const defaultPage: ContentType = x => x;

export type ContentType = (
  placeholder: Widget<
    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
  >
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>

let initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())

export const emptyAppState = (page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>): PublicSiteState =>
  ({
    ...initPagesStates,
    page: {
      ...initPagesStates.page,
      get_page: get_page,
      display: page(mk_pair(List(), none()))
    },
    browser: {
      viewport: 'desktop'
    },
    regionSwitch: {
      title: translation("regionSwitch.title"),
      description:  translation("regionSwitch.description"),
      closed: true,
      siteLanguage:  translation("regionSwitch.language"), 
      color: 'white',
      selectors: getRegionSwitchSelectors(),
      currentSelectorIndex: 0
    },
    header: {
      menu: 'closed',
      contactbar: 'closed',
      menu_header: {
        //nav_links: loadingAsyncState(() => {} Api.loadHeader()),
        breadcrumb: unloadedAsyncState()
      },
      showSearchBar: false,
      searchValue: ''
    },
    // cookiebar: {
      // selectedCookie: 'complete',
      // cookiebar: getCookieStatus(1) != 'undecided' ? 'closed' : 'open'
    // },
    footer: {
      menu_footer: {
        // nav_links: loadingAsyncState(),
      }
    },
    search: {
      pager: {
        current_page: 0,
        items_per_page: 10
      }
    },
    options: get_options('global-settings')
  } as PublicSiteState)
